import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import PatientCaregiver from 'common-src/models/PatientCaregiver';
import { getFormattedPhoneNumber } from 'common-src/models/PatientPhoneNumber/helpers';

import { InfoItem } from 'src/components/elements';
import BasePopup from 'src/popups/BasePopup';

import styles from './CaregiverDetailsPopup.module.scss';

const CaregiverDetailsPopup = ({ caregiver, onClose }) => (
  <BasePopup id="caregiver-details" open onClose={onClose} title="Caregiver Details">
    <div className={styles.grid}>
      <InfoItem title="First Name" content={caregiver.firstName} textId="first-name" small />
      <InfoItem title="Last Name" content={caregiver.lastName} textId="last-name" small />
      <InfoItem
        title="Is primary?"
        content={caregiver.isPrimary ? 'Yes' : 'No'}
        textId="is-primary"
        small
      />
      <InfoItem
        classNames={[styles.width75]}
        title="Email"
        content={caregiver.email}
        textId="email"
        small
      />
      <InfoItem
        title="Date of birth"
        content={caregiver.dateOfBirth ? moment(caregiver.dateOfBirth).format('MM/DD/YYYY') : '-'}
        textId="date-of-birth"
        small
      />
      <InfoItem
        title="Phone number"
        content={
          caregiver.phone
            ? getFormattedPhoneNumber(
                caregiver.phone.startsWith('+1') ? caregiver.phone.substring(2) : caregiver.phone,
              )
            : '-'
        }
        textId="phone"
        small
      />
      <InfoItem title="Phone Type" content={caregiver.phoneType} textId="phone-type" small />
      <InfoItem title="Sex" content={caregiver.sex} textId="sex" small />
      <InfoItem title="Relationship" content={caregiver.relationship} textId="relationship" small />
      <InfoItem
        title="Lives with patient?"
        content={caregiver.livesWithPatient ? 'Yes' : 'No'}
        textId="lives-with-patient"
        small
      />
      <InfoItem
        title="Medicare status"
        content={caregiver.medicareStatus}
        textId="medicare-status"
        small
      />
      <InfoItem title="MBI Number" content={caregiver.mbi} textId="mbi" small />
      <InfoItem
        title="Role years"
        content={caregiver.roleYears?.toString()}
        textId="role-years"
        small
      />
      <InfoItem
        title="Role months"
        content={caregiver.roleMonths?.toString()}
        textId="role-months"
        small
      />
    </div>
    <div className={[styles.grid, 'primary-border-t'].join(' ')}>
      <InfoItem
        title="Last Updated"
        content={caregiver.updatedAt ? moment(caregiver.updatedAt).format('MM/DD/YYYY') : '-'}
        textId="last-updated"
        small
      />
      <InfoItem
        classNames={[styles.width75]}
        title="Last Updated By"
        content={caregiver.updatedBy?.getName(true, false)}
        textId="updated-by"
        small
      />
    </div>
  </BasePopup>
);

CaregiverDetailsPopup.propTypes = {
  caregiver: PropTypes.exact(PatientCaregiver.schema),
  onClose: PropTypes.func,
};

export default CaregiverDetailsPopup;
